module.exports = __webpack_public_path__ + "img/content_make9-1.5678a2b1.jpg";